import eachDeep from 'deepdash/eachDeep';
import { setIdbItem } from './clientStorage';

const authorizedRCoreRoutes = new Set();
const rcoreBreadcrumbData = [];
let rootBreadcrumb = {};
const allowedCoreBreadcrumbs = [
  { nodeKey: 'common_jobs' },
  { nodeKey: 'Administrator_MenuLearningActivies' }
];

const ProcessTreeNodes = (nodes) => {
  eachDeep(
    nodes,
    (node) => {
      // eslint-disable-next-line no-param-reassign
      node.url = GetProcessedNodeUrl(node);
      if (node.level === 1) {
        if (node.nodeKey === 'admin_header') {
          rootBreadcrumb = {
            url: node.url.toLowerCase(),
            title: node.name,
            nodeKey: node.nodeKey,
            rpKey: node.rpKey
          };
        } else {
          rootBreadcrumb = undefined;
        }
      }
      const isAllowedCoreNode = allowedCoreBreadcrumbs.find((t) => t.nodeKey === node.nodeKey);
      if (node.isRcoreNode || isAllowedCoreNode !== undefined) {
        addToAuthorisedRCoreRoutes(node, rootBreadcrumb);
      }
    },
    { pathFormat: 'array', childrenPath: 'childNodes' }
  );
  setIdbItem('RCoreBreadCrumbData', rcoreBreadcrumbData);
  return authorizedRCoreRoutes;
};

const GetProcessedNodeUrl = (node) => {
  let { url } = node;
  if (!node.isRcoreNode) {
    url = GetProcessedCoreUrl(node);
  }
  return url;
};

const addToAuthorisedRCoreRoutes = (node, breadcrumb) => {
  const { url } = node;
  const pillarUrl = '/c/pillarredirect';
  if (
    (node.rpKey === 'ELIXHRUI' || node.rpKey === 'GAM' || node.rpKey === 'LM') &&
    url != null &&
    url !== ''
  ) {
    let nodeUrl = url.replace('#', '');
    if (nodeUrl.indexOf('?') > -1) nodeUrl = nodeUrl.substring(0, nodeUrl.indexOf('?'));
    if (!authorizedRCoreRoutes.has(nodeUrl)) {
      authorizedRCoreRoutes.add(nodeUrl.toLowerCase());

      const nodeBreadcrumbData = [];
      if (breadcrumb !== undefined) {
        nodeBreadcrumbData.push(breadcrumb);
      }
      nodeBreadcrumbData.push({
        url: nodeUrl.toLowerCase() !== pillarUrl ? nodeUrl.toLowerCase() : url.replace('#', ''),
        title: node.name,
        nodeKey: node.nodeKey,
        rpKey: node.rpKey
      });

      rcoreBreadcrumbData.push({
        routeUrl: nodeUrl.toLowerCase(),
        nodeKey: node.nodeKey,
        rpKey: node.rpKey,
        breadcrumbData: nodeBreadcrumbData
      });
    }
  }
};

const GetProcessedCoreUrl = (node) => {
  const { rpKey, nodeKey, relyingPartyURL } = node;
  const urlPrefix = '/c';
  let { url } = node;
  // If the url is already processed then just return
  if (url && url.indexOf('/c/') > -1) {
    return url;
  }
  if (url) {
    if (url.charAt(0) === '#') {
      url = url.replace('#', '');
    }
    // encode the url to use it in qs
    const encodedUrl = encodeURIComponent(url);
    const urlSuffix = `nodeKey=${nodeKey}&nodeUrl=${encodedUrl}`;
    if (rpKey !== 'ELIXHRUI') {
      let relyingPartyUrl = relyingPartyURL;
      if (relyingPartyUrl && relyingPartyUrl.charAt(relyingPartyUrl.length - 1) !== '/') {
        relyingPartyUrl += '/';
      }
      const encodeRPUrl = encodeURIComponent(relyingPartyUrl);
      if (rpKey !== 'AdvancedReport') {
        url = `${urlPrefix}/pillarRedirect?relyingParty=${rpKey}&url=${encodeRPUrl}${encodedUrl}&${urlSuffix}`;
      } else {
        url = `${urlPrefix}/pillarRedirect?relyingParty=${rpKey}&url=${encodeRPUrl}&${urlSuffix}`;
      }
    } else if (url.indexOf('http') === 0) {
      url = url.replace('$HOST_NAME', window.location.host);
    } else {
      url = `${urlPrefix}${url}${
        url.indexOf('?') > 0 ? '&' : '?'
      }relyingParty=${rpKey}&${urlSuffix}`;
    }
  }
  return url;
};

export { ProcessTreeNodes, GetProcessedNodeUrl };
